
<template>
  <div id="app" class="custom">
    <router-view/>
  </div>
</template>

<style src="@/vendor/styles/bootstrap.scss" lang="scss"></style>
<style src="@/vendor/styles/appwork.scss" lang="scss"></style>
<style src="@/vendor/styles/theme-soft.scss" lang="scss"></style>
<style src="@/vendor/styles/colors.scss" lang="scss"></style>
<style src="@/vendor/styles/uikit.scss" lang="scss"></style>
<style src="./style.scss" lang="scss"></style>

<style src="@/assets/fonts/fontawesome/all.css" lang="css"></style>
<style src="@/assets/css/line-awesome.css" lang="css"></style>
<style src="./custom.scss" lang="scss"></style>

<script>
export default {
  name: 'app',
  metaInfo: {
    title: 'Sipamer',
    titleTemplate: '%s - Sistem Informasi Pemantauan Merkuri'
  },
  updated () {
    // Remove loading state
    setTimeout(() => document.body.classList.remove('app-loading'), 1)
  },
  // computed: {
  //   currentUser() {
  //     return this.$store.state.auth.user;
  //   }
  // },
  // created() {
  // if (this.loggedIn) {
  //   this.$router.push('/app');
  // }
  // },
}
</script>
